import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const OrderListNoResultsWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
`;

export const OrderListNoResultsText = styled(typography.TitleOneRegularTypography)``;

export const OrdersListWrapper = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const OrdersListGridWrapper = styled.div`
  display: grid;
  grid-template: ${({ columnsCount }) => `1fr / repeat(${columnsCount}, 8fr)`};
  column-gap: 16px;
  padding: 0 24px;
`;

export const OrdersListDivider = styled.hr`
  width: calc(100% + 48px);
  grid-column: ${({ columnsCount }) => `1 / ${columnsCount + 2}`};
  margin: 0 -24px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.grey003};
`;

export const OrdersListHeader = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 10px 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const OrdersListItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 68px;
`;

export const OrdersListItemLink = styled(Link)`
  text-decoration: none;
`;

export const OrdersListItemText = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const OrdersListItemSubText = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
`;

export const OrderListItemStatus = styled(typography.BodyTextTwoRegularTypography)`
  width: 150px;
  margin: 0;
  padding: 5px 0;
  text-align: center;
  border-radius: 4px;

  ${({ color, backgroundColor }) => `
    color: ${color};
    background-color: ${backgroundColor};
  `};
`;

export const OrderListItemStatusReason = styled(typography.BodyTextTwoRegularTypography)`
  max-width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const DelayedOrder = styled.div`
  height: 100%;
  border-left: 3px #db3226 solid;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
  margin: -24px;
`;

export const DelayedOrderTextAlert = styled(typography.BodyTextTwoRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const DelayedOrderIcon = styled.i`
  color: ${({ theme }) => theme.colors.redMain};
  font-style: normal;
  margin-left: 4px;

  &:before {
    content: '\\e90c';
    font-family: 'Icomoon';
  }
`;

export const DelayedOrderWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const OrderInfoSticker = styled(typography.BodyTextTwoRegularTypography)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  width: fit-content;
  color: ${({ color }) => color};

  &:before {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    font-size: 18px;
  }
`;
